import { PrintMarkerClip } from './print/PrintMarkerClip'
import { MapMarker, MAP_MAX_ZOOM } from '@wehunt/map'
import { pinLabelCssPx } from '../lib/geo'
import { lineLabelCenter, nameLabelBox } from '../lib/mapLineLabel'
import {
  MAPLIBRE_LAW_ZOOM_OFFSET,
  mapPxPerProjectedMetre,
} from '../lib/mapLines'
import type { MapAppearance } from '../lib/mapAppearance'
import type { GeoLine, GeoPt } from '../lib/types'
import { MapNameLabel } from './MapNameLabel'

export function LineNameMarker({
  line,
  zoom,
  appearance,
  dimOutside,
}: {
  line: GeoLine
  zoom: number
  appearance: MapAppearance
  dimOutside?: GeoPt[] | null
}) {
  if (!line.name?.trim()) return null
  const size = pinLabelCssPx(zoom, MAP_MAX_ZOOM)
  const center = lineLabelCenter(
    line.points,
    line.width,
    nameLabelBox(line.name, size, appearance.labelBackground),
    mapPxPerProjectedMetre(zoom + MAPLIBRE_LAW_ZOOM_OFFSET),
  )
  if (!center) return null
  return (
    <MapMarker lat={center.lat} lon={center.lon} anchor="center">
      <PrintMarkerClip point={center} frame={dimOutside}>
        <MapNameLabel name={line.name} size={size} appearance={appearance} />
      </PrintMarkerClip>
    </MapMarker>
  )
}
